import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";

@Component({
	selector: "security-token-unit-display",
	templateUrl: "./security-token-unit-display.component.html",
	imports: [CoreModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecurityTokenUnitDisplayComponent {
	@Input() amount = 0;
}
